import { DocumentCard, Faq } from 'sections/Resources/FreightTemplates/BillOfLading/types';

export const documentsCardData: DocumentCard[] = [
  {
    id: 1,
    iconName: 'icon-files.svg',
    heading: 'Commercial Invoice',
    url: '/resources/freight-templates/commercial-invoice',
    fileName: 'commercial_invoice',
  },
  {
    id: 2,
    iconName: 'icon-files.svg',
    heading: 'Packing List',
    url: '/resources/freight-templates/packing-list',
    fileName: 'packing_list',
  },
  {
    id: 3,
    iconName: 'icon-files.svg',
    heading: 'Certificate of Origin',
    url: '/resources/freight-templates/certificate-of-origin',
    fileName: 'certificate_of_origin',
  },
];

export const faq: Faq[] = [
  {
    id: "1",
    question: "What is the difference between a Straight Bill of Lading and an Order Bill of Lading?",
    answer: (cn: Function) => (
      `
        <p class='${cn('faq__answer-paragraph')}'>
          A Straight Bill of Lading is non-negotiable and made out to a specific consignee. An Order Bill of Lading is negotiable and allows the goods to be transferred to another party by endorsement.
        </p>
      `
    ),
  },
  {
    id: "2",
    question: "How can I track my shipment using the Bill of Lading?",
    answer: (cn: Function) => (
      `
        <p class='${cn('faq__answer-paragraph')}'>
          Use your Bill of Lading number on the carrier’s or tracking platform’s website. It will show the shipment status, current location, and estimated arrival.
        </p>
      `
    ),
  },
  {
    id: "3",
    question: "What are the consequences of errors in a Bill of Lading?",
    answer: (cn: Function) => (
      `
        <p class='${cn('faq__answer-paragraph')}'>
          Mistakes can cause delays in delivery, customs issues, legal disputes, and even rejected insurance claims. Always check the details before it is issued.
        </p>
      `
    ),
  },
  {
    id: "4",
    question: "How can I ensure compliance with international regulations for Bills of Lading?",
    answer: (cn: Function) => (
      `
        <p class='${cn('faq__answer-paragraph')}'>
          Make sure all shipment details are correct, use the right type of Bill of Lading, and follow both export and import country rules. Keep clear records for audits.
        </p>
      `
    ),
  },
  {
    id: "5",
    question: "What is a Sea Waybill, and when should it be used?",
    answer: (cn: Function) => (
      `
        <p class='${cn('faq__answer-paragraph')}'>
          A Sea Waybill is a non-negotiable transport document. It is used when goods are delivered to a known consignee and ownership will not change during transit.
        </p>
      `
    ),
  },
  {
    id: "6",
    question: "What are the benefits of using digital tools for Bill of Lading management?",
    answer: (cn: Function) => (
      `
        <p class='${cn('faq__answer-paragraph')}'>
          Digital tools reduce errors, speed up document processing, improve visibility, and prevent loss of paperwork. They also make it easier to track changes and approvals.
        </p>
      `
    ),
  },
  {
    id: "7",
    question: "Can a Bill of Lading be amended after it has been issued?",
    answer: (cn: Function) => (
      `
        <p class='${cn('faq__answer-paragraph')}'>
          Yes, but only with approval from the carrier or freight forwarder. Changes should be documented properly to avoid confusion or disputes.
        </p>
      `
    ),
  },
  {
    id: "8",
    question: "How can I use a Bill of Lading to secure financing for my shipment?",
    answer: (cn: Function) => (
      `
        <p class='${cn('faq__answer-paragraph')}'>
          A negotiable Bill of Lading can act as proof of ownership, so a bank may use it as collateral for trade financing, especially under a letter of credit.
        </p>
      `
    ),
  },
];